<template>
  <b-card class="application-card" no-body v-if="application">
    <b-card-body class="application-card-body d-flex flex-row justify-content-top align-items-top" v-b-modal="referralID">
      <!-- <font-awesome-icon class="red position-absolute" icon="times" :style="{ top: 0, right: 0 }"/> -->
      <img class="flex-shrink-0 referral-contact-picture mr-2" v-if="showApplicantsName"
        :src="avatarURL" height="40" width="40"/>
      <div class="referral-details d-flex flex-column">
        <div class="text-black" v-if="showApplicantsName">
          <span v-if="application.status === 'CONFIRMED'">✅ </span>
          <strong v-if="application.fullName">{{ application.fullName }}</strong>
          <strong v-else>Candidate</strong>
        </div>
        <div class="text-black">
          <template v-if="showApplicantsName">Applied</template>
          <template v-if="!showApplicantsName">👤&nbsp;Your contact applied</template>

          <template v-if="job && job.title">for <strong>{{ job.title }}</strong> on</template>
          <template v-else>on</template>

          <strong>{{ application.created | formatDate('Do MMMM YYYY') }}</strong>
        </div>
      </div>
    </b-card-body>
    <b-card-footer class="application-card-footer" v-if="application.status">
      <template v-if="showApplicantsName && !application.userAnswers && !(application.status === 'REJECTED' || application.status === 'HIRED')">
        <application-supporting-questions-modal :ref="`application-supporting-questions-${applicationID}`" :id="`application-supporting-questions-${applicationID}`" :application="application" :contact="contact"/>
        <h4><a class="text-danger" href="#" @click.prevent v-b-modal="`application-supporting-questions-${applicationID}`">Awaiting Answers</a></h4>
      </template>
      <template v-else-if="application.status === 'INTERVIEW'">
        <h4>Interview stage</h4>
      </template>
      <template v-else-if="application.status === 'REJECTED' || application.status === 'HIRED'">
        <h4><router-link :to="{ name: 'JobShow', params: { jobID } }">View Job</router-link></h4>
      </template>
      <template v-else>
        <h4>In Progress</h4>
      </template>
    </b-card-footer>

    <contact-modal v-if="showApplicantsName && contact" :id="referralID" :contact="contact"/>
  </b-card>
</template>

<script>
import ContactModal from '@/modals/contact-profile';
// import ReferQuestions from '@/components/job-referrals/refer-questions';
// import ReferralsEmployeeAnswerQuestionsMutation from '@/graphql/mutations/ReferralsEmployeeAnswerQuestions.gql';
import ApplicationSupportingQuestionsModal from '@src/modals/application-supporting-questions';
import { createMD5String } from '@/lib/hashing';

export default {
  name: 'JobApplicationLaneItem',
  props: {
    application: {
      type: Object,
    },
  },
  components: {
    ApplicationSupportingQuestionsModal,
    ContactModal,
  },
  data: () => ({
    referAnswers: {},
  }),
  computed: {
    applicationID() {
      const { id } = this.application;
      return id || null;
    },
    job() {
      const { job } = this.application;
      return job && job.id ? job : null;
    },
    jobID() {
      const { job } = this.application;
      return job && job.id ? job.id : null;
    },
    referral() {
      const { referral } = this.application;
      return referral && referral.id ? referral : null;
    },
    referralID() {
      const { referral } = this.application;
      return referral && referral.id ? referral.id : null;
    },
    contact() {
      const { referral } = this;
      return referral && referral.contact && referral.contact.id ? referral.contact : null;
    },
    contactID() {
      const { referral } = this;
      return referral && referral.contact && referral.contact.id ? referral.contact.id : null;
    },
    contactModalID() {
      if (this.referralID && this.contactID) {
        return `referral-contact-modal-${this.referralID}-${this.contactID}`;
      } else {
        return null;
      }
    },
    avatarURL() {
      if (this.contact) {
        return `/static/images/avatars/main${this.contact.avatar || 1}.png`;
      } else if (this.application && this.application.emailAddress) {
        return `https://www.gravatar.com/avatar/${createMD5String(this.application.emailAddress)}.jpg?d=mp`;
      } else {
        return null;
      }
    },
    showApplicantsName() {
      const { company } = this.$root;
      const { showApplicantsName = true } = (company || {}).sitePreferences || {};
      return showApplicantsName;
    },
  },
  methods: {
    // async sendReferAnswers() {
    //   const { id, contact: { id: contactID }, job: { id: jobID }, status } = this.referral;
    //   if (!id || !contactID || !jobID || !status) {
    //     throw new TypeError('Missing id/contactID/jobID/status from referral');
    //   }
    //
    //   await this.$apollo.mutate({
    //     mutation: ReferralsEmployeeAnswerQuestionsMutation,
    //     variables: {
    //       input: {
    //         contactID,
    //         jobID,
    //         ...this.referAnswers,
    //         status,
    //       },
    //     },
    //   });
    //
    //   this.$root.$emit('bv::hide::modal', `awaiting-answers-${id}`);
    // },
  },
};
</script>

<style lang="scss">
@import './../../scss/variables';

.application-card {

  .application-card-body {
    .referral-details {
      font-size: $small-font-size;
      min-width: 15rem;
      text-align: left;
    }

    img {
      border-radius: 50%;
    }
  }
  .application-card-footer {
    background-color: white;
    text-align: center;

    h4 {
      margin-bottom: 0px;
      font-size: $small-font-size;
      a {
        font-weight: 500;
      }
    }
  }
  .circle, .match-label, .btn, .dropdown, .workplace {
    margin: 0 auto;
  }
  .workplaces {
    height: 10rem;
    border-top: 1px solid rgba(0, 0, 0, 0.125);
  }

  .btn, .dropdown {
    max-width: 13rem;
    min-width: 10rem;
    width: 100%;
    height: 3rem;
    padding-bottom: 0.3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/job-applications/lane-item.vue